"use strict";

var headerHeight = function headerHeight() {
  var header = document.querySelector('header');
  var height = header.offsetHeight;
  return height - 10;
};

var smallNav = function smallNav() {
  var navigation = document.querySelector('#main-nav');

  if (window.pageYOffset > headerHeight()) {
    navigation.className = 'header-navigation navigation--sm';
  } else {
    navigation.className = 'header-navigation';
  }
};

smallNav();
document.addEventListener('scroll', function () {
  return smallNav();
});